<template>
  <div class="wrong-network-container">
    <div class="title">Wrong network</div>
    <div class="suggest">
      Please switch to
      <pre>{{ config.configWallet.chainName }}</pre>
    </div>
  </div>
</template>

<script>
import config from '@/config';

export default {
  data() {
    return { config };
  }
};
</script>

<style lang="scss" scoped>
.wrong-network-container {
  width: 370px;
  height: 150px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  .title {
    color: #d3180c;
    font-family: Inter-Bold;
  }
  .suggest {
    color: #354165;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
